// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".img-holder[data-v-d9eb8bb4] {\n  width: 100% !important;\n  height: 140px !important;\n  text-align: center;\n  margin-right: 0 !important;\n}\n.img-holder img[data-v-d9eb8bb4] {\n  height: 100%;\n  -o-object-fit: contain;\n     object-fit: contain;\n}", ""]);
// Exports
module.exports = exports;
